import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MonitorIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.4 14h5.2M8 11.333V14m-3.38-2.667h6.76c1.092 0 1.638 0 2.055-.218.367-.191.665-.497.852-.874.213-.428.213-.988.213-2.108V5.2c0-1.12 0-1.68-.213-2.108a1.98 1.98 0 0 0-.852-.874C13.018 2 12.472 2 11.38 2H4.62c-1.092 0-1.638 0-2.055.218a1.98 1.98 0 0 0-.852.874C1.5 3.52 1.5 4.08 1.5 5.2v2.933c0 1.12 0 1.68.213 2.108.186.377.485.683.852.874.417.218.963.218 2.055.218" /></svg>
  );
}

export default MonitorIcon;
